<dialog
  #dialog
  qai-dialog
  [heading]="'call.CERT_ACK_TITLE' | transloco"
  [description]="''"
  [showClose]="false"
>
  <div class="acknowledgement-content">
    @if (!isCameraOn) {
      <p class="camera-warning">
        ⚠️ {{ (isCameraInterruption() ? 'call.CERT_ACK_CAMERA_OFF_DURING_CALL' : 'call.CERT_ACK_CAMERA_WARNING') | transloco }}
      </p>
    }

    <p class="acknowledgement-text">{{ 'call.CERT_ACK_TEXT_1' | transloco }}</p>
    <p class="acknowledgement-text">{{ 'call.CERT_ACK_TEXT_2' | transloco }}</p>

    <div class="actions">
      <button
        qai-button
        kind="primary"
        size="medium"
        (click)="acceptAndBegin()"
        [disabled]="isLoading || !isCameraOn"
      >
        @if (!isLoading) {
          {{ (isCameraInterruption() ? 'call.CERT_ACK_RESUME_CALL' : 'call.CERT_ACK_ACCEPT_AND_BEGIN') | transloco }}
        } @else {
          {{ 'call.CERT_ACK_PROCESSING' | transloco }}
        }
      </button>

      @if (isCameraInterruption()) {
        <button
          qai-button
          kind="secondary"
          size="medium"
          (click)="onCancel()"
        >
          {{ 'call.CERT_ACK_END_CALL' | transloco }}
        </button>
      }
    </div>
  </div>
</dialog>
